import type { ReactNode } from 'react'
import { cn } from '../lib/cn'
import { Icons } from '../icons/registry'

/** A platform-independent checkbox that keeps native input and keyboard semantics. */
export function Checkbox({
  checked,
  onChange,
  disabled = false,
  children,
  className,
}: {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  children: ReactNode
  className?: string
}) {
  return (
    <label className={cn(
      'group flex items-start gap-3 text-ui leading-relaxed',
      disabled ? 'cursor-not-allowed text-muted-foreground' : 'cursor-pointer text-foreground',
      className,
    )}>
      <input
        type="checkbox"
        className="peer sr-only"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span
        aria-hidden
        className={cn(
          'mt-0.5 grid size-5 shrink-0 place-items-center rounded-[4px] border transition-colors duration-fast',
          'peer-focus-visible:ring-2 peer-focus-visible:ring-primary/50 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-surface',
          checked
            ? 'border-primary bg-primary text-primary-foreground [&_.wf-icon]:text-primary-foreground'
            : 'border-hairline bg-surface-sunken text-transparent group-hover:border-muted-foreground',
          disabled && 'opacity-50',
        )}
      >
        {checked ? <Icons.check size="xs" /> : null}
      </span>
      <span className="min-w-0 flex-1">{children}</span>
    </label>
  )
}
